import Card from "react-bootstrap/Card";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { APIEndpoints } from "utils/APIEndpoints";
import MaterialIcon from "common/MaterialIcon/MaterialIcon";

const VideoLibrary = ({ labels, videos, participantDetails }) => {
  const [show, setShow] = useState(false);
  const [file, setFile] = useState({});
  const [open, setOpen] = useState(false);

  const handleShow = (e) => {
    if (e.type === "external"|| e.type === "additional-info-section") {
      window.open(e?.link["ALL"], "_blank");
    } else {
      setFile(getVideoFileName(e));
      setShow(true);
    }
  };
  const handleClose = () => {
    setFile({});
    setShow(false);
  };

  const getVideoFileName = (data) => {
    const planId = participantDetails?.extPlanId;
    return data?.link[planId] || data?.link["ALL"];
  };

  const filterVideos = (videos) => {
    const planId = participantDetails?.extPlanId;
    return videos.filter((e) => e?.link[planId] || e?.link["ALL"]);
  };
  const allVideos = filterVideos(videos);

  const normalVideos = allVideos.filter(
    (v) => v.type !== "additional-info-section"
  );

  const additionalInfoVideos = allVideos.filter(
    (v) => v.type === "additional-info-section"
  );

  const handleToggle = () => setOpen(prev => !prev);

  const renderCard = (e, index) => (
    <div className="col-12 col-sm-6 col-xl-6 pe-4 mb-5" key={e.id}>
      <Card
        style={{
          width: "100%",
          maxWidth: "399px",
          aspectRatio: "16/9",
        }}
        className="video-card d-inline-block mb-3"
        onClick={() => handleShow(e)}
      >
        <Card.Body className="p-0">
          {e.type === "external" || e.type === "additional-info-section" ? (
            <img
              src={APIEndpoints.images(localStorage.getItem("tenant"), e.image)}
              alt={e.label}
              width="100%"
            />
          ) : (
            <iframe
              title={`Video-${index}`}
              src={getVideoFileName(e)}
              id="iframeId"
              style={{
                width: "100%",
                maxWidth: "399px",
                pointerEvents: "none",
                aspectRatio: "16/9",
              }}
            ></iframe>
          )}
        </Card.Body>
      </Card>
      {e.label && <div className="fw-bold label">{e.label}</div>}
      <small>{e.description}</small>
    </div>
  );
  return (
    <>
      <section className="section-two row pb-5 videos">
        <div className="header mb-4 py-1">
          {labels?.learningCenter?.videoLibrary}
        </div>

        <div className="d-flex flex-wrap videos-md">
          {normalVideos.map((e, index) => renderCard(e, index))}
        </div>
        <div className="mt-4 additional-insights">
          {/* Header */}
          <div
            className="additional-insights-header d-flex align-items-center"
            onClick={handleToggle}
          >
            <span className="title">
              {labels?.learningCenter?.additionalInsights}
            </span>
            <div class="border-div"></div>
            <MaterialIcon
              wrapperClassName="iconClass"
              iconName="arrow_circle_down" // Toggle icon
            />
          </div>
          {/* Body */}
          {open && (
            <div className="mt-4 additional-insights-body">
              <div className="d-flex flex-wrap videos-md">
                {additionalInfoVideos.map((e, index) => renderCard(e, index))}
              </div>
            </div>
          )}
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        id="iframeModal"
        contentClassName="align-items-center"
      >
        <Modal.Body>
          <iframe
            width="960"
            height="540"
            src={file}
            title={file}
            className="d-block video-iframe"
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoLibrary;
